module.exports = __webpack_public_path__ + "static/media/mq.3dcb40dd.png";